import React from 'react';
import { Button, Icon } from 'antd';

import { Link } from 'react-router-dom';
import LinkLegalDoc from './LegalDoc/LinkLegalDoc';

const urls = [
  {
    slug: 'requests',
    url: '/executorship/request',
    order: 1,
  },
  /*{
    slug: 'freightage',
    url: false,
  },*/
  {
    slug: 'offers',
    url: '/executorship/offer',
    order: 2,
  },
  {
    slug: 'orders',
    url: '/executorship/order',
    order: 3,
  },
  {
    slug: 'employees',
    url: '/employees/',
    order: 4,
  },
  {
    slug: 'vehicles',
    url: '/vehicles/',
    order: 5,
  },
  {
    slug: 'documents',
    url: '/documents/documents_by_orders',
    order: 6,
  },
  {
    slug: 'customers',
    url: '/customers/',
    order: 7,
  },
  {
    slug: 'settings',
    url: '/system_settings/profile',
    order: 8,
  },
  /*{
    slug: 'templates',
    url: '/templates',
  },*/
  {
    slug: 'companies',
    url: false,
  },

  {
    slug: 'finances',
    url: '/finances',
  },
  {
    slug: 'calendar',
    url: false,
  },
  {
    slug: 'vehicles_monitoring',
    url: false,
  },
];

class MainPanel extends React.Component {
  state = {
    buttons: [],
  };
  static getDerivedStateFromProps(props, state) {
    const { buttons } = props;
    if (props) {
      const newButtons = buttons.map(button => {
        const btn = urls.find(url => button.slug === url.slug);
        button.url = btn ? btn.url : null;
        button.order = btn ? btn.order : 100;
        return button;
      });
      newButtons.sort((a, b) => (b.sort > a.sort ? 1 : -1));
      newButtons.sort((a, b) => (b.active > a.active ? 1 : -1));
      state = { buttons: newButtons };
    }
    return state;
  }
  render() {
    const { buttons } = this.state;
    const { isBurger } = this.props;
    // console.log(buttons);
    return (
      <div id="buttons" className="basic-area">
        <div className="vertical-area-control">
          {isBurger ? null : <h1>Панель управления</h1>}
          <div className={isBurger ? 'btn-main-area__burger' : 'btn-main-area'}>
            {isBurger && (
              <Button type={isBurger ? 'link' : 'primary'}>
                <Link
                  onClick={isBurger && this.props.handleClick()}
                  style={{ display: 'flex', alignItems: 'center' }}
                  to="/executorship/order/add"
                >
                  Сформировать Заказ
                  <Icon
                    style={{
                      fontSize: 24,
                      marginLeft: 18,
                    }}
                    type="plus-circle"
                  />
                </Link>
              </Button>
            )}
            {buttons.sort((a, b) => b.active - a.active).map(button =>
              !button.active ? (
                <Button
                  key={button.slug}
                  type={isBurger ? 'link' : 'primary'}
                  disabled
                >
                  {button.name}
                </Button>
              ) : (
                <Button
                  onClick={isBurger && this.props.handleClick()}
                  key={button.slug}
                  type={isBurger ? 'link' : 'primary'}
                >
                  <Link to={button.url}>{button.name}</Link>
                </Button>
              )
            )}
          </div>
          <div
            className="burger__documents"
            style={{
              margin: '60px 0px -10px 0px',
              textDecorationLine: 'underline',
            }}
          >
            <LinkLegalDoc isBurger={isBurger} />
          </div>
        </div>
      </div>
    );
  }
}

export default MainPanel;
